export const collectionConstants = {
    RESET: 'RESET',
    COLLECTION_FETCHING: 'COLLECTION_FETCHING',
    COLLECTION_FETCHED: 'COLLECTION_FETCHED',
    COLLECTION_SUBMITTING: 'COLLECTION_SUBMITTING',
    COLLECTION_SUBMITTED: 'COLLECTION_SUBMITTED',
    GET_WAYBILL_FOR_COLLECTION: 'GET_WAYBILL_FOR_COLLECTION',
    GET_WAYBILL_FOR_COLLECTION_OTHER_CHARGE: 'GET_WAYBILL_FOR_COLLECTION_OTHER_CHARGE',
    LOAD_COLLECTION: 'LOAD_COLLECTION',
    GET_COLLECTION_BY_ID: 'GET_COLLECTION_BY_ID',
    GET_COLLECTION_BY_ID_OTHERCHARGE: 'GET_COLLECTION_BY_ID_OTHERCHARGE',
    CALCULATED_CWT: 'CALCULATED_CWT',
    EXCESS_PAY_GL: 'EXCESS_PAY_GL',
    OTHER_INCOME_ACCOUNT: 'OTHER_INCOME_ACCOUNT',
    GENERATE_RECEIPT: 'GENERATE_RECEIPT',
}